// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"ee7abbfb","194":"ee7abbfb","237":"686c27b2","298":"7763178d","571":"0bf9203d","974":"702a9b2e"}[chunkId] + ".chunk.css";
};